import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {connect} from "react-redux";

function Sidebar(props) {
    const location = useLocation();
    const [isPayment, setIsPayment] = useState(window.location.pathname.includes("/portal/payment"));
    const user_type = props.loginData[0].userType;
    const dismissClick = () => {
        const isMobile = window.innerWidth <= 768; // Adjust breakpoint as needed
        if (isMobile) {
            document.getElementById("mobile_btn")?.click();
        }
    };

    useEffect(() => {
        setIsPayment(window.location.pathname.includes("/portal/payment"));
    }, [location.pathname]);

    useEffect(() => {
        // Apply saved theme settings from local storage
        document.querySelector("html").setAttribute("data-theme", localStorage.getItem("theme") || "light");
        document.querySelector("html").setAttribute("data-sidebar", localStorage.getItem("sidebarTheme") || "light");
        document.querySelector("html").setAttribute("data-color", localStorage.getItem("color") || "primary");
        document.querySelector("html").setAttribute("data-topbar", localStorage.getItem("topbar") || "white");

        // Dark mode toggle
        const darkModeToggle = document.getElementById("dark-mode-toggle");
        const lightModeToggle = document.getElementById("light-mode-toggle");
        const darkMode = localStorage.getItem("darkMode");

        function enableDarkMode() {
            document.documentElement.setAttribute("data-theme", "dark");
            darkModeToggle?.classList.remove("activate");
            lightModeToggle?.classList.add("activate");
            localStorage.setItem("darkMode", "enabled");
        }

        function disableDarkMode() {
            document.documentElement.setAttribute("data-theme", "light");
            lightModeToggle?.classList.remove("activate");
            darkModeToggle?.classList.add("activate");
            localStorage.removeItem("darkMode");
        }

        if (darkModeToggle && lightModeToggle) {
            if (darkMode === "enabled") {
                enableDarkMode();
            } else {
                disableDarkMode();
            }

            darkModeToggle.addEventListener("click", enableDarkMode);
            lightModeToggle.addEventListener("click", disableDarkMode);
        }

        // Handle sidebar theme
        const sidebarBgContainer = document.getElementById("sidebarbgContainer");

        function handleSidebarBgChange() {
            const sidebarBg = document.querySelector('input[name="sidebarbg"]:checked')?.value || null;

            if (sidebarBg) {
                document.body.setAttribute("data-sidebarbg", sidebarBg);
                localStorage.setItem("sidebarBg", sidebarBg);
            } else {
                document.body.removeAttribute("data-sidebarbg");
                localStorage.removeItem("sidebarBg");
            }
        }

        function handleInputChange() {
            const theme = document.querySelector('input[name="theme"]:checked')?.value || "light";
            const sidebarTheme = document.querySelector('input[name="sidebar"]:checked')?.value || "light";
            const color = document.querySelector('input[name="color"]:checked')?.value || "primary";
            const layout = document.querySelector('input[name="LayoutTheme"]:checked')?.value || "default";
            const topbar = document.querySelector('input[name="topbar"]:checked')?.value || "white";

            // Apply theme settings
            document.documentElement.setAttribute("data-theme", theme);
            document.documentElement.setAttribute("data-sidebar", sidebarTheme);
            document.documentElement.setAttribute("data-color", color);
            document.documentElement.setAttribute("data-layout", layout);
            document.documentElement.setAttribute("data-topbar", topbar);

            localStorage.setItem("theme", theme);
            localStorage.setItem("sidebarTheme", sidebarTheme);
            localStorage.setItem("color", color);
            localStorage.setItem("layout", layout);
            localStorage.setItem("topbar", topbar);

            if (layout === "mini") {
                document.body.classList.add("mini-sidebar");
                document.body.classList.remove("layout-box-mode");
            } else if (layout === "box") {
                document.body.classList.add("layout-box-mode");
                document.body.classList.remove("mini-sidebar");
            } else {
                document.body.classList.remove("layout-box-mode", "mini-sidebar");
            }

            if (layout === "box" && sidebarBgContainer) {
                sidebarBgContainer.classList.add("show");
            } else if (sidebarBgContainer) {
                sidebarBgContainer.classList.remove("show");
            }
        }

        function resetThemeSettings() {
            handleInputChange();
            document.body.removeAttribute("data-sidebarbg");
            localStorage.removeItem("sidebarBg");
        }

        // Add event listeners
        document.querySelectorAll('input[name="theme"]').forEach((radio) => radio.addEventListener("change", handleInputChange));
        document.querySelectorAll('input[name="sidebar"]').forEach((radio) => radio.addEventListener("change", handleInputChange));
        document.querySelectorAll('input[name="color"]').forEach((radio) => radio.addEventListener("change", handleInputChange));
        document.querySelectorAll('input[name="LayoutTheme"]').forEach((radio) => radio.addEventListener("change", handleInputChange));
        document.querySelectorAll('input[name="topbar"]').forEach((radio) => radio.addEventListener("change", handleInputChange));
        document.querySelectorAll('input[name="sidebarbg"]').forEach((radio) => radio.addEventListener("change", handleSidebarBgChange));

        // Cleanup event listeners when component unmounts
        return () => {
            darkModeToggle?.removeEventListener("click", enableDarkMode);
            lightModeToggle?.removeEventListener("click", disableDarkMode);
            document.querySelectorAll('input[name="theme"]').forEach((radio) => radio.removeEventListener("change", handleInputChange));
            document.querySelectorAll('input[name="sidebar"]').forEach((radio) => radio.removeEventListener("change", handleInputChange));
            document.querySelectorAll('input[name="color"]').forEach((radio) => radio.removeEventListener("change", handleInputChange));
            document.querySelectorAll('input[name="LayoutTheme"]').forEach((radio) => radio.removeEventListener("change", handleInputChange));
            document.querySelectorAll('input[name="topbar"]').forEach((radio) => radio.removeEventListener("change", handleInputChange));
            document.querySelectorAll('input[name="sidebarbg"]').forEach((radio) => radio.removeEventListener("change", handleSidebarBgChange));
        };
    }, []); // Runs only once on component mount


    return (
        <div className="sidebar" id="sidebar">
            <div className="sidebar-inner slimscroll">
                <div id="sidebar-menu" className="sidebar-menu">
                <ul>
                    <li>
                        <h6 className="submenu-hdr"><span>Main</span></h6>
                        <ul>
                            <li><Link onClick={()=>{ dismissClick() }} to="/portal/payment/dashboard"><i className="ti ti-layout-dashboard"></i><span>Dashboard</span></Link></li>
                            <li><Link onClick={()=>{ dismissClick() }} to="/portal/payment/pay-now"><i className="ti ti-currency-dollar"></i><span>Pay Now</span></Link></li>
                            <li><Link onClick={()=>{ dismissClick() }} to="/portal/payment/history"><i className="fa fa-file-invoice-dollar"></i><span>Payment History</span></Link></li>
                            {
                                user_type === 'returning' ?
                                    <li><a onClick={()=>{ dismissClick() }} href="https://student.hensarduniversity.edu.ng/" target={'_blank'} referrerPolicy={'no-referrer'} ><i className="fa fa-dashboard"></i><span> Student Portal</span></a></li> :
                                    <li><a onClick={()=>{ dismissClick() }} href="https://admission.hensarduniversity.edu.ng/" target={'_blank'} referrerPolicy={'no-referrer'} ><i className="fa fa-dashboard"></i><span> Admission Portal</span></a></li>
                            }
                        </ul>
                    </li>
                </ul>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        loginData: state.LoginDetails,
        currentSemester: state.currentSemester
    };
};

export default connect(mapStateToProps, null)(Sidebar);